module.exports = __webpack_public_path__ + "static/media/thumb.2752f5bc.jpg";